const $inject = ['$http', '$q', 'moment'];

const userCardsService = ($http, $q, moment) => {
  return {
    getTypeByValue: getTypeByValue,
    hasCardExpired: hasCardExpired,
    cards: [],
    Card: card
  };

  
  function card() {
    return {
      Title: null,
      CardHolder: null,
      DisplayNumber: null,
      ExpiryMonth: null,
      ExpiryYear: null,
      CardType: null,
      SegmentTypes:[]
    }
  }

  function hasCardExpired(payment) {
    const currentYear = parseInt(moment().format('YYYY'));
    const currentMonth = parseInt(moment().format('MM'));
    const paymentYear = parseInt(payment.ExpiryYear);
    const paymentMonth = parseInt(payment.ExpiryMonth);

    return paymentYear < currentYear || (paymentYear === currentYear && paymentMonth < currentMonth);
  }

  function getTypeByValue(value) {
    value = value ? value.replace(/\s/g, '') : '';

    const defaultCardType = {
      Code: null,
      Value: null
    };

    const cardTypes = {
      MasterCard: {
        Code: 'CA',
        Value: 'MasterCard'
      },
      Visa: {
        Code: 'VI',
        Value: 'Visa'
      },
      AmericanExpress: {
        Code: 'AX',
        Value: 'AmericanExpress'
      }
    };

    return cardTypes[value] || defaultCardType;
  }
};

userCardsService.$inject = $inject;

export default userCardsService;


// WEBPACK FOOTER //
// ./src/services/userCardsService.js